import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CompassionateCareForCityPets from "./sections/CompassionateCareForCityPets";
import OurHappyPatients from "./sections/OurHappyPatients";
import UrgentCarePharmacy from "./sections/UrgentCarePharmacy";
import HowWeSupportYourPet from "./sections/HowWeSupportYourPet";
import VoicesOfPetParents from "./sections/VoicesOfPetParents";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CompassionateCareForCityPets />
      <OurHappyPatients />
      <UrgentCarePharmacy />
      <HowWeSupportYourPet />
      <VoicesOfPetParents />
      <Footer />
    </div>;
}